import React, { FC, useEffect } from 'react';

import { useQuery } from '@apollo/client';
import { Box, Typography } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { CustomPagination } from './@ui/Pagination';
import { useHistory } from 'react-router-dom';
import StarsIcon from '@material-ui/icons/Stars';
import StreamerItem from './StreamerItem';
import VerticalList from './VerticalList';
import findAllUsers, {
  findAllUsersResponse,
} from 'core/graphql/queries/findAllUsers';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Avatar from "../pictures/dummyAvatar.svg"
import { makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@mui/material/TextField';
import SearchUSer, {
  searchAllResponse
} from "../core/graphql/queries/searchUsers"
import Sort from "../pictures/sort.svg"

const limit = 10;


interface propsItem {
  type: String
}

const StreamerList: FC<propsItem> = ({
  type
}) => {




  const [page, setPage] = React.useState(() => {
    const pageParam = window.location.search.split("=")[1];
    const parsed = parseInt(pageParam);
    return isNaN(parsed) || parsed < 1 ? 1 : parsed;
  });
  const [search, setSearch] = React.useState("");
  const [count, setCount] = React.useState(0)
  const [sort, SetSort] = React.useState(false)
  const QueryMultiple = () => {
    const res1 = useQuery<findAllUsersResponse>(
      findAllUsers,
      {
        variables:
          { limit: limit, skip: limit * (page - 1) },
        errorPolicy: 'all',
        skip: !!search // Skip this query when searching
      }
    );
    const res2 = useQuery<searchAllResponse>(
      SearchUSer, {
      variables: {
        text: search,
        type: type
      },
      errorPolicy: 'all',
      skip: !search // Skip this query when not searching
    }
    )

    return [res1, res2]
  }

  const [
    { loading: loading1, data: data1, error: error1, refetch },
    { loading: loading2, data: data2, error: error2 },
  ] = QueryMultiple()


  const [list, SetList] = React.useState<any[]>([])
  const [listSearch, SetListSearch] = React.useState<any[]>([])


  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    history.push({
      search: `?page=${value}`
    })
  };

  const history = useHistory()

  const handleClick = (id: any) => {
    history.push(`/streamer/${id}`)
  }

  useEffect(() => {
    console.log('StreamerList data1:', data1);
    console.log('StreamerList error1:', error1);
    console.log('StreamerList loading1:', loading1);
    
    if (data1 && 'findUserMany' in data1 && data1.findUserMany) {
      const users = data1.findUserMany || [];
      console.log('StreamerList users:', users);
      // For pagination, we'll assume there are more if we got a full page
      const total = users.length === limit ? (page * limit) + 1 : page * limit;
      if (total % 10 > 0) {
        setCount(Math.floor(total / 10) + 1);
      } else {
        setCount(Math.floor(total / 10) || 1);
      }
      // Map users to match expected format
      const mappedUsers = users.map((user: any) => ({
        _id: user._id,
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.email,
        totalSpent: user.balanceInPennies ? (user.balanceInPennies / 100) : 0 // Convert pennies to dollars, default to 0
      }));
      SetList(mappedUsers);
    } else if (!loading1 && !error1) {
      // No data and not loading and no error - empty result
      SetList([]);
      setCount(1);
    }

    if (data2 && 'searchUser' in data2 && data2.searchUser) {
      SetListSearch(data2.searchUser);
    } else {
      SetListSearch([]);
    }

    if (!search && refetch) {
      refetch();
    }
  }, [page, search, type, data1, data2, refetch]);

  const handleInput = (event: any) => {
    setSearch(event.target.value)
  };



  // console.log(data1?.allUserList.total%10,"hellos")

  const useStyles = makeStyles<Theme>((theme) => ({
    image: {
      width: '55px',
      height: '55px',
    },
    artistContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    SearchField: {
      display: "flex",
      alignItems: "center",
      gap: "0.3rem",
      marginBottom: "20px"
    },
    ClearBtn: {
      background: 'none',
      outline: 'none',
      border: 'none',
      color: "#fff",
      fontWeight: 600,
      display: search ? "block" : "none",

    }


  }));

  const handleSort = () => {
    SetSort(!sort)
    if (list) {
      const sorted = [...list].sort((a: any, b: any) => {
        const aSpent = a.totalSpent || 0;
        const bSpent = b.totalSpent || 0;
        return sort ? aSpent - bSpent : bSpent - aSpent;
      });
      SetList(sorted);
    }
    if (listSearch) {
      const sorted = [...listSearch].sort((a: any, b: any) => {
        const aSpent = a.totalSpent || 0;
        const bSpent = b.totalSpent || 0;
        return sort ? aSpent - bSpent : bSpent - aSpent;
      });
      SetListSearch(sorted);
    }
  }


  const classes = useStyles();

  // let count = data1 ? Math.floor(data1?.allUserList?.total / 10) : 1;

  // Show error message if queries fail
  if (error1 || error2) {
    console.error('StreamerList errors:', error1, error2);
    console.error('Error details:', {
      error1: error1?.message,
      error1Network: error1?.networkError,
      error1GraphQL: error1?.graphQLErrors,
      error2: error2?.message,
      error2Network: error2?.networkError,
      error2GraphQL: error2?.graphQLErrors,
    });
  }

  return (
    <>
      <div className={classes.SearchField}>
        <h2 style={{ color: "#3D7670" }}>Search</h2>
        <TextField className={classes.SearchBox} id="outlined-basic" variant="outlined" value={search} onInput={(e) => handleInput(e)} />
        <button className={classes.ClearBtn} style={{ cursor: 'pointer' }} onClick={() => {
          setSearch("")
        }}>
          Clear
        </button>
      </div>

      {(loading1 || loading2) && (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <Typography style={{ color: '#fff' }}>Loading streamers...</Typography>
        </Box>
      )}

      {(error1 || error2) && (
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" p={3}>
          <Typography style={{ color: '#ff9800', marginBottom: '10px' }}>
            Error loading streamers. Please try again.
          </Typography>
          {(error1?.graphQLErrors?.[0]?.message || error1?.networkError?.message) && (
            <Typography style={{ color: '#ff6b6b', fontSize: '12px', textAlign: 'center' }}>
              {error1.graphQLErrors?.[0]?.message || error1.networkError?.message || 'Unknown error'}
            </Typography>
          )}
        </Box>
      )}

      {!search ?
        <>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="caption table">
              <TableHead>
                <TableRow style={{ color: 'white !important' }}>
                  <TableCell width="5%">
                    #
                  </TableCell>
                  <TableCell>
                    Name
                  </TableCell>
                  <TableCell>
                    Email
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', gap: "0.5rem" }}>
                      Spent($)
                      <img src={Sort} onClick={handleSort} style={{ cursor: 'pointer' }} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list && list.length > 0 ? list.map((val: any, idx: number) => (
                  <TableRow onClick={() => handleClick(val._id)} style={{ cursor: 'pointer' }}>
                    <TableCell>
                      {((page - 1) * 10) + ++idx}
                    </TableCell>
                    <TableCell width={'40%'}>
                      <>
                        <div className={classes.artistContainer}>
                          <img src={Avatar} className={classes.image} />
                          {`${val.firstName} ${val.lastName}`}
                        </div>
                      </>
                    </TableCell>
                    <TableCell width={'40%'}>
                      <>
                          {val.email}
                      </>
                    </TableCell>
                    <TableCell className='colorBlue'>
                      {val.totalSpent}
                    </TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: 'center', color: '#fff', padding: '20px' }}>
                      {loading1 ? 'Loading...' : 'No streamers found'}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <div style={{ marginTop: "30px" }}>
            <Pagination count={count} page={page} onChange={handleChange} />
          </div>

        </>

        : <>
          <div>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} aria-label="caption table">
                <TableHead>
                  <TableRow className={classes.thead}>
                    <TableCell style={{ color: 'white' }}>
                      #
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>
                      Name
                    </TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', gap: "0.5rem" }}>
                        Spent($)
                        <img src={Sort} onClick={handleSort} style={{ cursor: 'pointer' }} />
                      </div>
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listSearch && listSearch.length > 0 ? listSearch.map((title: any, idx: number) => (
                    <TableRow>
                      <TableCell style={{ color: 'white' }}>
                        {((page - 1) * 10) + ++idx}
                      </TableCell>
                      <TableCell>
                        {title.firstName} {title.lastName}
                      </TableCell>
                      <TableCell className='colorBlue'>
                      {title.totalSpent}
                    </TableCell>
                      <TableCell style={{ cursor: 'pointer' }} onClick={() => handleClick(title._id)}>
                        View
                      </TableCell>
                    </TableRow>
                  )) : (
                    <TableRow>
                      <TableCell colSpan={4} style={{ textAlign: 'center', color: '#fff', padding: '20px' }}>
                        {loading2 ? 'Loading...' : 'No results found'}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>}
    </>
  );
};

export default StreamerList;
